var hasOwnProperty = Object.prototype.hasOwnProperty;
var isArray = Array.isArray;

function cnb() {
  var len = arguments.length;
  if (!len) return "";
  var str = "",
      item,
      i,
      n;

  for (i = 0; i < len; i++) {
    if (!(item = arguments[i])) continue;

    if (typeof item === "string") {
      str && (str += " "), str += item;
      continue;
    }

    if (typeof item !== "object") continue;

    if (item.push && isArray(item)) {
      if (item = cnb.apply(this, item)) {
        str && (str += " "), str += item;
      }

      continue;
    }

    for (n in item) {
      if (hasOwnProperty.call(item, n) && item[n] && n) {
        str && (str += " "), str += n;
      }
    }
  }

  return str;
}

export default cnb;